module.exports = __webpack_public_path__ + "img/graph-1-chart.c48163bb.png";